import { render, staticRenderFns } from "./CookieElement.vue?vue&type=template&id=3c53cdc8"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonComponent: require('/home/node/app/components/ui/ButtonComponent.vue').default,ControllerCookie: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCookie.js').default})
